<template>
  <span>
    <div @click="navigatoTo"
        class="col-md-9 margin-left-14">
        <a> 
            {{ notify.message }}.
            <i class="fa fa-check text-success"></i>
        </a>
        <br>
    </div>
    <div class="col-md-1" @click="close">
        <i class="fa fa-window-close icon"></i> 
    </div>
    <div class="space-50"></div>
    <small class="pull-right">{{ notify.date | time }}</small>
  </span>
</template>

<script>
export default {
  'name': 'NotifyBoletoPayment',
  props: {
    notify: {
      type: Object,
      required: true
    }
  },
  methods: {
    navigatoTo () {
      this.$router.push({name: 'rents_details', params: {rentId: this.notify.rent_id}})
      this.$emit('decreaseNotification', this.notify)
    },
    close () {
      this.$emit('decreaseNotification', this.notify)
    }
  }
}
</script>


// WEBPACK FOOTER //
// NotifyBoletoPayment.vue?31db03f6